import type { JSX } from "react";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@mailflare/ui";
import type { Label, MailboxId } from "@mailflare/shared";

import { Sidebar } from "@/features/mailboxes/components/sidebar";

export interface MobileSidebarProps {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly mailboxId: MailboxId;
  readonly labels: readonly Label[];
  readonly unreadCount?: number;
}

/** Off-canvas navigation for small screens, built on the shadcn Sheet. */
export function MobileSidebar({
  open,
  onOpenChange,
  mailboxId,
  labels,
  unreadCount,
}: MobileSidebarProps): JSX.Element {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-72 max-w-[85vw] gap-0 p-0">
        <SheetHeader className="sr-only">
          <SheetTitle>Navigation</SheetTitle>
          <SheetDescription>Mailbox folders and labels</SheetDescription>
        </SheetHeader>
        <Sidebar
          mailboxId={mailboxId}
          labels={labels}
          {...(unreadCount !== undefined ? { unreadCount } : {})}
          onNavigate={() => onOpenChange(false)}
        />
      </SheetContent>
    </Sheet>
  );
}
